//This file is automatically rebuilt by the Cesium build process.
export default "float czm_writeNonPerspective(float value, float w) {\n\
return value * w;\n\
}\n\
vec2 czm_writeNonPerspective(vec2 value, float w) {\n\
return value * w;\n\
}\n\
vec3 czm_writeNonPerspective(vec3 value, float w) {\n\
return value * w;\n\
}\n\
vec4 czm_writeNonPerspective(vec4 value, float w) {\n\
return value * w;\n\
}\n\
";
